var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "_pcirc",
      class: { _busy: _vm.busy },
      style: { width: _vm.width, height: _vm.height },
      attrs: { inert: _vm.blocking && _vm.busy }
    },
    [
      _c("transition", { attrs: { name: "_pcirct", duration: 1000 } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show && _vm.ready,
                expression: "show && ready"
              }
            ],
            staticClass: "_pcirco",
            attrs: {
              role: "progressbar",
              "aria-valuenow": _vm.value,
              "aria-valuemin": _vm.value !== undefined ? _vm.min : undefined,
              "aria-valuemax": _vm.value !== undefined ? _vm.max : undefined
            }
          },
          [
            _c("svg", { attrs: { viewBox: "0 0 64 64" } }, [
              _c("circle", {
                staticClass: "_pcircbg",
                attrs: { cx: "32", cy: "32", r: "24" }
              }),
              _c("circle", {
                staticClass: "_pcircfg",
                class: { _inf: _vm.value === undefined },
                style: { "transition-duration": _vm.duration + "ms" },
                attrs: {
                  cx: "32",
                  cy: "32",
                  r: "24",
                  "stroke-dasharray": "150.7968",
                  "stroke-dashoffset": _vm.dashoffset
                },
                on: { transitionend: _vm._done }
              })
            ])
          ]
        )
      ]),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }